import { featureFlagsSlice } from "./feature-flags.slice";

export const featureFlagsReducer = featureFlagsSlice.reducer;
export { useFeatureFlag, useFeatureFlagsLoader } from "./hooks";
